import mixins from 'vue-typed-mixins';

import { E補助科目フラグ, Eフェーズ種別 } from '@/openapi/enum';
import { データApi, 勘定科目Api, 勘定科目ListItemResponse, 部門ListItemResponse } from '@/openapi/user';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import 償却Service from '@/classes/service/分析計画/償却Service';
import { 償却FunctionType, 償却 } from '@/classes/service/分析計画/償却Type';

export default mixins(計画書Mixin, 事業所Mixin).extend({
  name: 'M償却ListMixin',

  data(): {
    v償却: 償却 | null;
    勘定科目s: 勘定科目ListItemResponse[];
    eフェーズ種別: Eフェーズ種別 | null;
    service: 償却Service | null;
    functionType: 償却FunctionType | null;
    maxNo: number;
  } {
    return {
      v償却: null,
      勘定科目s: [],
      eフェーズ種別: null,
      service: null,
      functionType: null,
      maxNo: 0,
    };
  },

  methods: {
    async initialize償却Service(
      eフェーズ種別: Eフェーズ種別.分析フェーズ | Eフェーズ種別.計画フェーズ,
      functionType: 償却FunctionType,
      部門s: 部門ListItemResponse[] = []
    ): Promise<void> {
      // 各画面の初期設定
      this.eフェーズ種別 = eフェーズ種別;
      this.service = new 償却Service(eフェーズ種別);
      this.functionType = functionType;

      // 勘定科目を取得
      const response = await UserApiUtility.ogApi(勘定科目Api).list勘定科目(this.事業所.pk, E補助科目フラグ.通常);
      this.勘定科目s = response.data;
      // Serviceで必要なデータをセット
      this.service.set勘定科目s = this.勘定科目s;
      if (部門s.length > 0) this.service.set部門s = 部門s;
      // 償却データの検索
      this.load償却List();
    },

    async load償却List(): Promise<void> {
      const options = {
        params: {
          sj: `償却_${this.eフェーズ種別 === Eフェーズ種別.分析フェーズ ? '分析' : '計画'}`,
        },
      };
      // 番号の最大値を出すために償却データを全件取得する
      const response = await UserApiUtility.ogApi(データApi).listデータ(
        this.計画書.pk,
        this.service!.getRelationalE入力分類s(),
        undefined,
        options
      );
      // 番号の最大値を取得する
      if (response.data.length > 0) {
        this.maxNo = Math.max(...response.data.map((d) => d.c番号));
      }
      // 分析の時は分析フェーズのデータのみに絞る
      const targetData =
        this.eフェーズ種別 === Eフェーズ種別.分析フェーズ
          ? response.data.filter((item) => item.cフェーズ種別 === Eフェーズ種別.分析フェーズ)
          : response.data;
      this.v償却 = this.service!.parse(targetData, { functionType: this.functionType! });
    },
  },
});
